export enum WheelRaffleItemStatus {
  SCHEDULED = "scheduled",
  LIVE = "live",
  ENDED = "ended",
  DRAWN = "drawn",
}

export type RaffleVisibility = "open" | "private";

export interface RaffleTier {
  tier_code: string; //example: diamond
  display_name: string;
  sort_order: number; //чем больше, тем выше статус
}

export type EligibilityCode =
  "tier_too_low" | "private_join_required" | "raffle_not_active";

export interface RaffleEligibility {
  eligible: boolean;
  code?: EligibilityCode; //Present when eligible=false
}

// Прогресс зрителя по условиям розыгрыша.
export interface RaffleCompletion {
  has_joined: boolean;
  is_participant: boolean;
  volume_done_usdt: string;
  volume_required_usdt: string;
  progress_percent: number; //0..100
  eligibility: RaffleEligibility;
}

// Общие поля карточки во всех списках v2; деньги — строки с 2 знаками.
export interface RaffleBase {
  id: number;
  visibility: RaffleVisibility;
  status: WheelRaffleItemStatus;
  prize_pool_usdt: string;
  starts_at: string;
  ends_at: string;
  drawn_at?: string; //Present when status=drawn
  time_remaining_sec: number; //0 if drawn or window ended
  symbols: string[];
  volume_usdt: string;
  volume_done_usdt: string;
  progress_percent: number;
  winners_count: number;
  participants_count: number;
  is_creator: boolean;
  is_participant: boolean;
  has_joined: boolean; //Always true for open
  eligibility: RaffleEligibility;
  stream_url: string | null;
  my_prize_usdt?: string | null; //when viewer won
  is_winner?: boolean;
  winner?: number[]; //fid всех победителей; пусто, пока не разыгран
}

// promos / search / detail: статусы объектами и блок completion.
export interface Raffle extends RaffleBase {
  allowed_participant_tiers: RaffleTier[];
  completion: RaffleCompletion;
}

// recent: статусы только кодами, без completion; победители всегда есть.
export interface RecentRaffle extends RaffleBase {
  allowed_participant_tiers: string[];
  is_winner: boolean;
  winner: number[];
}
